import angular from 'angular';
import LocationService from './location.service.js';
import LocationSchema from './location.schema';

let locationModule = angular.module('location', [])

    .service('LocationService', LocationService)
    .constant('LocationSchema', LocationSchema)
    .name;

export default locationModule;
